import { Languages } from "lucide-react";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { setUiLanguage } from "@/lib/setUiLanguage";

export function LanguageToggle(): ReactElement {
  const { t, i18n } = useTranslation();
  const languageValue = i18n.language.startsWith("pt") ? "pt-BR" : "en";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          className="size-8 shrink-0"
          aria-label={t("common.language")}
        >
          <Languages className="size-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-36">
        <DropdownMenuRadioGroup
          value={languageValue}
          onValueChange={(lng) => void setUiLanguage(lng)}
        >
          <DropdownMenuRadioItem value="en">English (US)</DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="pt-BR">Português (BR)</DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
